$(document).ready(function(){
    var header = $('header');
    var headerOffset = header.offset().top;

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > headerOffset) {
        header.addClass('sticky');
        } else {
        header.removeClass('sticky');
        }
    });
    
    $(".menuic").click(function() {
        $(this).toggleClass("active");
        $("body").toggleClass("active");
    });
}); //end jquery

